import LabRepository from "./LabRepository";
import { generateUrl } from "@/shared/utils";

const resource = "/notes";

export default {
    getAll(params) {
        return LabRepository.get(`${resource}?limit=all`, { params });
      },
      get(id, params) {
        return LabRepository.get(`${resource}/${id}`, { params });
      },
      getSome(params) {
        return LabRepository.get(`${resource}${generateUrl(params)}`);
      },
      create(payload) {
        return LabRepository.post(resource, payload);
      },
      update(id, payload) {
        return LabRepository.put(`${resource}/${id}`, payload);
      },
      suspend(id) {
        return LabRepository.delete(`${resource}/${id}`);
      },
}